import {request, getToken} from "./request";
import {getFingerPrint} from "../../js/util/fingerPrint";

function getLiveReq(method, bizContent={}) {
    return request({
        url: '/toodo/tdk/platformLive?token=' + getToken(),
        data: {
            method,
            bizContent
        }
    })
}

// 获取直播详情
function getPlatformLive(bizContent={}) {
    return getLiveReq('/platformLive', bizContent)
}

// 获取文字直播，用户处于文字直播界面时轮询此接口（建议10秒一次），同时不需要在调用online接口
function getPlatformLiveWords(bizContent){
    bizContent.deviceId = getFingerPrint()
    return getLiveReq('/getPlatformLiveWords', bizContent)
}

// 获取直播预约
function getPlatformLiveOrders(bizContent={}) {
    return getLiveReq('/getPlatformLiveOrders', bizContent)
}

// 获取直播评论，用户处于直播聊天界面时轮询此接口（建议3秒一次），同时不需要在调用online接口
function getPlatformLiveComment(bizContent={}) {
    bizContent.deviceId = getFingerPrint()
    return getLiveReq('/getPlatformLiveComment', bizContent)
}

// 评论直播
function commentLive(bizContent={}) {
    return getLiveReq('/commentLive', bizContent)
}

//进入直播主页，用户处于直播中需要半分钟上传一次，超过一分钟状态没更新视为离开
function onLine(bizContent={}) {
    bizContent.deviceId = getFingerPrint()
    return getLiveReq('/onLine', bizContent)
}

//获取直播关注收藏状态
function getPlatformLiveStatus(bizContent={}) {
    return getLiveReq('/getPlatformLiveStatus', bizContent)
}
//预约直播
function orderPlatformLive(bizContent={}) {
    return getLiveReq('/orderPlatformLive', bizContent)
}

// 获得用户预约时间段
function getUserOrder(bizContent={}) {
    return getLiveReq('/getUserOrder', bizContent)
}

export const apiLive = {
    getPlatformLive,
    getPlatformLiveWords,
    getPlatformLiveOrders,
    getPlatformLiveComment,
    getPlatformLiveStatus,


    commentLive,
    onLine,
    orderPlatformLive,
    getUserOrder,
}